import { forwardRef } from 'react'

export const BinIcon = forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>(
  (props, ref) => (
    <svg
      ref={ref}
      width="18"
      height="20"
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke={props.stroke || '#141C24'}
      {...props}
    >
      <path
        d="M7 9V15M11 9V15M1 5H17M3 5V16C3 17.6569 4.34315 19 6 19H12C13.6569 19 15 17.6569 15 16V5H3ZM12 5V3C12 1.89543 11.1046 1 10 1H8C6.89543 1 6 1.89543 6 3V5H12Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
)

BinIcon.displayName = 'BinIcon'
